import styled from '@emotion/styled'

import RuleConditionGroup from './RuleConditionsGroup'
import { RuleCondition } from 'types/rules'

const MAX_VISIBLE_CONDITIONS = 2

const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spaces.space2};
	padding: ${({ theme }) => `${theme.spaces.space2} ${theme.spaces.space3}`};
`

const LabelColumn = styled(Column)`
	padding: 0;
	border-right: none;
`

const LogicalSeparator = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${({ theme }) => `${theme.spaces.space2} ${theme.spaces.space4}`};
	background-color: ${({ theme }) => theme.colors.light.surfaceDecorative};
	border-radius: ${({ theme }) => theme.borderRadiuses.xxl};
	align-self: flex-start;
	${({ theme }) => theme.typography.smallcaps};
	color: ${({ theme }) => theme.colors.light.grayscale[600]};
`

type RuleConditionsProps = {
	urlConditions: RuleCondition[]
	domainConditions: RuleCondition[]
}

function RuleConditions({ urlConditions, domainConditions }: RuleConditionsProps) {
	const hasUrlConditions = urlConditions.length > 0
	const hasDomainConditions = domainConditions.length > 0

	return (
		<>
			<LabelColumn>
				<LogicalSeparator>IF</LogicalSeparator>
			</LabelColumn>

			<Column>
				<RuleConditionGroup
					conditions={hasUrlConditions ? urlConditions : domainConditions}
					maxVisible={MAX_VISIBLE_CONDITIONS}
				/>
			</Column>

			<LabelColumn>{hasUrlConditions && hasDomainConditions && <LogicalSeparator>AND</LogicalSeparator>}</LabelColumn>

			<Column>
				{hasUrlConditions && hasDomainConditions && (
					<RuleConditionGroup conditions={domainConditions} maxVisible={MAX_VISIBLE_CONDITIONS} />
				)}
			</Column>

			<LabelColumn>
				<LogicalSeparator>THEN</LogicalSeparator>
			</LabelColumn>
		</>
	)
}

export default RuleConditions
